<wr-base-dialog
  status="info"
  header="Gebäudeteile auswählen"
  [submitResponse]="onSubmit.bind(this)"
  [disableSubmit]="disableSubmit"
>
  <hau-form [formGroup]="form">
    <hau-form-field
      label="Gebäudeteile"
      [validation]="form.validation.sections"
      cols="12"
    >
      <wr-building-section-multi-select
        [buildingId]="buildingId"
        formControlName="sections"
      ></wr-building-section-multi-select>
    </hau-form-field>
  </hau-form>
</wr-base-dialog>
